import React from "react";
import "./ContactSection.css";
import { Phone, MessageCircle } from "lucide-react";

const ContactSection = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        
        <div className="contact-header fade-in-up">
          <h2 className="contact-title gold-gradient-text">Get In Touch</h2>
          <p className="contact-subtitle">
            Call us now for instant credit card swiping services
          </p>
        </div>

        <div className="contact-grid">
          <a 
            href="tel:9884135738" 
            className="contact-card fade-in-up"
            style={{ animationDelay: "0.1s" }}
          >
            <div className="contact-icon-wrapper">
              <Phone className="contact-icon" size={32} />
            </div>
            <div className="contact-info">
              <p className="contact-label">Velachery Office</p>
              <p className="contact-number">9884135738</p>
            </div>
          </a>

          <a 
            href="tel:6385417845" 
            className="contact-card fade-in-up"
            style={{ animationDelay: "0.2s" }}
          >
            <div className="contact-icon-wrapper">
              <MessageCircle className="contact-icon" size={32} />
            </div>
            <div className="contact-info">
              <p className="contact-label">All Locations</p>
              <p className="contact-number">6385417845</p>
            </div>
          </a>
        </div>

      </div>
    </section>
  );
};

export default ContactSection;